/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { Controller, type Control, type ControllerProps, type FieldValues } from 'react-hook-form';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, type TextFieldProps } from '@mui/material';

export type CustomSelectFieldProps<T extends FieldValues = FieldValues> =Omit<TextFieldProps, 'name' | 'type' | 'onChange'> & {
    validation?: ControllerProps['rules']
    name: string
    control?: Control<any, any>
    label?: string
    disabled:boolean
    maxLength?: number
    options: any[],
    onChange?: (value: any) => void
    valueKey?: string;
    labelKey?: string;
    objectOnChange?: boolean
    halfWidth? : boolean;
    value? : string | undefined;
}

const CustomSelectField:React.FC<CustomSelectFieldProps>= ( {  validation = {},
    required,
    name,
    disabled,
    control,
    helperText,
    fullWidth,
    halfWidth,
    sx,
    label,
    maxLength,
    options = [],
    valueKey='value',
    labelKey='name',
    objectOnChange,
    value,
    ...rest}) =>{



    if (required) {
        validation.required = `This field is required`
    }






    return (
        <div style={rest.style} >
            <Controller
                name={name}
                control={control}
                rules={validation}
                defaultValue={(name === "citizenship")? value : ""}
                render={({ field: { value, onChange, onBlur }, fieldState: { invalid, error } }) =>
                    <>
                        <FormControl size="small" className={'lowHeight'} id={name + '_formControl'} error={!!error} fullWidth>
                            <InputLabel id={name + 'Label'}>{required ? label+ ' *' : label}</InputLabel>
                            <Select
                                required={required}
                                labelId={name}
                                id={name}
                                value={value}
                                label={required ? label+ ' *' : label}
                                disabled={disabled}
                                onChange={(event: any) => {
                                    let item: number | string = event.target.value;
                                    if (typeof rest.onChange === 'function') {
                                        if (objectOnChange) {
                                            item = options.find(i => i[valueKey] === item)
                                        }
                                        rest.onChange(item)
                                    }
                                    onChange(event.target.value);

                                }}
                            >{
                                    options.map((option) => {
                                        if (!halfWidth){
                                            return <MenuItem key={option.value} value={option[valueKey]} style={{ maxWidth: "396px !important"}}>{option[labelKey]}</MenuItem>
                                        } else {
                                            return <MenuItem key={option.value} value={option[valueKey]} style={{ maxWidth : "196px !important"}}>{option[labelKey]}</MenuItem>
                                        }
                                    })
                                }


                            </Select>
                           
                            {!!error  && <FormHelperText>{error?.message}</FormHelperText>}
                        </FormControl>
                    </>
                }
            />
        </div>


    )
}

export default CustomSelectField;